export const COLLECT_HOME_URL = "/marketing/dashboard";
export const INTEGRATIONS_CHECKLIST_URL = "/integrations/checklist?initialVisit=true";
export const COMPLY_HOME_URL = "/comply/privacy-centre/theme";

export const KNOWLEDGE_CENTER_URL = "https://learn.dataships.io";

export const EMAIL_MARKETING_CHECKLIST_URL = `${KNOWLEDGE_CENTER_URL}/marketing-compliance#email-compliance-checklist`;
export const COLLECT_ONBOARDING_PATH = "/onboarding/marketing";

export const KLAVIYO_CREATE_API_KEY_URL =
  "https://www.klaviyo.com/create-private-api-key";

export const SHOPIFY_ADMIN_URL = "https://www.shopify.com/admin";

export const SHOPIFY_CHECKOUT_SETTINGS_URL = `${SHOPIFY_ADMIN_URL}/settings/checkout`;

export const SHOPIFY_APP_SETTINGS_URL = `${SHOPIFY_ADMIN_URL}/settings/apps`;

export const SUPPORT_MEETING_URL =
  "https://meetings.hubspot.com/dataships/customer-success";

export const MAILTO_SUPPORT = "mailto:support@dataships.io";

export const NAVIGATE_FORWARDS = "FORWARDS";

export const NAVIGATE_BACKWARDS = "BACKWARDS";

export const COLLECT_SIGNUP_URL = `${COLLECT_ONBOARDING_PATH}/signup`;

export const COLLECT_ONBOARDING_SCREENS = {
  PROFILE: "/profile",
  SHOPIFY_ENABLED: "/klaviyo-api-key",
  KLAVIYO_ENABLED: "/klaviyo-opt-in",
  KLAVIYO_OPTIN_UPDATED: "/privacy-policy-url",
  PRIVACY_POLICY_URL_SAVED: "/privacy-email",
  PRIVACY_EMAIL_SAVED: "/add-shopify-widget",
  SHOPIFY_WIDGET_INSTALLED: "/disable-shopify-consent",
  SHOPIFY_CONSENT_DISABLED: "/shopify-preview",
  SHOPIFY_PREVIEW: "/setup-complete",
};

export const MOBILE_COLLECT_CHART_HEIGHT = 193;
export const DESKTOP_COLLECT_CHART_HEIGHT = 350;

export const OWNER_ROLE_ID = 40;

export const URL_REGEX =
  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i;
